import { render, staticRenderFns } from "./PaymentsFilter.vue?vue&type=template&id=76d83bd6"
import script from "./PaymentsFilter.vue?vue&type=script&lang=js"
export * from "./PaymentsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports